import { useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Check, Play, Volume2 } from "lucide-react";
import { clsx } from "clsx";
import { NOTIFICATION_SOUNDS, getSelectedSoundId, playNotificationSound, setSelectedSoundId } from "@/lib/notification-sound";
import { registerPushDevice } from "@/services/push-device-api";
import { useAppStore } from "@/store/app-store";

export function NotificationSoundPicker() {
  const pushToken = useAppStore((state) => state.pushToken);
  const [selected, setSelected] = useState(getSelectedSoundId);
  const [saving, setSaving] = useState(false);

  const choose = async (id: string) => {
    setSelected(id);
    setSelectedSoundId(id);
    playNotificationSound(id);
    if (pushToken && Capacitor.isNativePlatform()) {
      setSaving(true);
      try {
        await registerPushDevice({ token: pushToken, platform: Capacitor.getPlatform(), sound: id });
      } catch (error) {
        console.error("Failed to save notification sound preference", error);
      } finally {
        setSaving(false);
      }
    }
  };

  return (
    <div className="notification-card">
      <div className="notification-card__head">
        <h2><Volume2 size={16} /> Notification sound</h2>
        {saving && <small>Saving…</small>}
      </div>
      <p className="notification-sound__hint">Choose the tone that plays for booking alerts. On Android the new sound applies to alerts received after you pick it.</p>
      <div className="notification-sound__list">
        {NOTIFICATION_SOUNDS.map((sound) => (
          <div key={sound.id} className={clsx("notification-sound__row", selected === sound.id && "is-selected")}>
            <button type="button" className="notification-sound__pick" onClick={() => void choose(sound.id)}>
              <span className="notification-sound__check">{selected === sound.id && <Check size={14} />}</span>
              <span>{sound.label}</span>
            </button>
            <button
              type="button"
              className="notification-sound__preview"
              aria-label={`Preview ${sound.label}`}
              onClick={() => playNotificationSound(sound.id)}
            >
              <Play size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
